var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtensiveCoverageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 61,
    viewBox: "0 0 84 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.375,
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "#F7F6F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_11605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.293 46.6665H45.543L47.668 29.6665H56.168L58.293 46.6665Z",
    stroke: "#187C85",
    strokeWidth: 0.971429,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4167 46.6667H35.625L37.75 34.625H46.9583",
    stroke: "#187C85",
    strokeWidth: 0.971429,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4987 46.6668H25.707L27.1237 39.5835H37.0404",
    stroke: "#187C85",
    strokeWidth: 0.971429,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.707 27.5417L35.6237 23.2917L34.207 19.75L42.707 22.5833L39.1654 31.0833L37.7487 27.5417L27.832 31.7917L25.707 27.5417Z",
    stroke: "#187C85",
    strokeWidth: 0.971429,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.332 31.7915L54.7487 44.5415",
    stroke: "#187C85",
    strokeWidth: 0.971429,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_11605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(25 13.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensiveCoverageIcon);
export default __webpack_public_path__ + "static/media/extensive-coverage-icon.5e7bfe058dec3f36afd50dd24b4e5a8d.svg";
export { ForwardRef as ReactComponent };